import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/form-controls/Button";
import Select from "../../components/form-controls/Select";
import Input from "../../components/form-controls/Input";
import { AccountService } from "../../services/AccountsService";
import { AlertService } from "../../services/Alert";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import useModal from "../../hooks/useModal";
import { useTranslation } from "react-i18next";
interface WhatsAppBusinessModalProps {
    show: boolean;
    onRequestClose: (refresh: boolean) => void;
}

function WhatsAppBusinessModal({ show, onRequestClose }: WhatsAppBusinessModalProps) {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const modal = useRef<HTMLDivElement>(null);

    useModal(modal, show)

    const defaultValues = {
        // id: 8,
        account_id: 0,
        provider: 'meta',

        phone_number: '',
        waba_id: '',

        url: '',
        cm_apiToken: '',
        cm_token: '',
        meta_phone_number_id: '',
        meta_access_token: '',

        cm_number: '',
        cm_wab_id: '',
        meta_phone_number: '',
        meta_waba_id: '',
        meta_app_id: '',
    }

    const { register, watch, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const submit = async (data) => {
        try {
            data.account_id = account.id;
            data.cm_number = data.provider === 'cm' ? data.phone_number : '',
            data.cm_wab_id = data.provider === 'cm' ? data.waba_id : '',
            data.meta_phone_number = data.provider === 'cm' ? '' : data.phone_number ,
            data.meta_waba_id = data.provider === 'cm' ? '' : data.waba_id ,
            data.meta_app_id = data.provider === 'cm' ? '' : data.meta_app_id ,

            delete data.phone_number;
            delete data.waba_id;
            
            await AccountService.saveWABSettings(data);
            await onRequestClose(true)

            reset(defaultValues)

            AlertService.toastSuccess('Se guardó correctamente la configuración')
        } catch (error) {
            console.error(error)
            AlertService.error('¡Error!', 'No se pudo guardar la configuración, intenta más tarde.')
        }
    }

    const getSettings = async() => {
        const { data } = await AccountService.getWABSettings(account.id)
        reset({
            provider: data.provider,

            phone_number: data.provider === 'cm' ? (data.cm_number || '') : data.provider === 'meta' ? (data.meta_phone_number || '') : '',
            waba_id: data.provider === 'cm' ? (data.cm_wab_id || '' ) : data.provider === 'meta' ? (data.meta_waba_id || '') : '',

            url: data.url || '',
            cm_apiToken: data.cm_apiToken || '',
            cm_token: data.cm_token || '',
            meta_phone_number_id: data.meta_phone_number_id || '',
            meta_access_token: data.meta_access_token || '',

            cm_number: data.cm_number || '',
            cm_wab_id: data.cm_wab_id || '',
            meta_phone_number: data.meta_phone_number || '',
            meta_waba_id: data.meta_waba_id || '',
            meta_app_id: data.meta_app_id || '',
        })
    }

    useEffect(() => {
        if (show) {
            getSettings()
        }
    }, [show]);

    return (
        <div className="modal fade" ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t("platform.channels.config-wasab.config-title")}</h4>
                            <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Select
                                    label={t("platform.channels.config-wasab.provider")}
                                    data={ [
                                        {value: '', text: 'Selecciona un proveedor', disabled: true },
                                        {value: 'cm', text: 'Concepto Móvil' },
                                        {value: 'meta', text: 'WhatsApp Cloud' },
                                    ] }
                                    errors={errors.provider}
                                    {...register('provider')}
                                />
                            </div>

                            <div className="mb-3">
                                <Input label={t("platform.channels.config-wasab.number-phone")} errors={errors.phone_number} {...register('phone_number', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                            <div className="mb-3">
                                <Input label= {t("platform.channels.config-wasab.wasab-id")} errors={errors.waba_id} {...register('waba_id', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                            {
                                watch('provider') === 'cm' ? (
                                    <>
                                        <div className="mb-3">
                                            <Input label='URL *' errors={errors.url} {...register('url', { required: true, setValueAs: (value) => value.trim() })} />
                                        </div>
                                        <div className="mb-3">
                                            <Input label='Token *' errors={errors.cm_token} {...register('cm_token', { required: true, setValueAs: (value) => value.trim() })} />
                                        </div>
                                        <div className="mb-3">
                                            <Input label='API Token *' errors={errors.cm_apiToken} {...register('cm_apiToken', { required: true, setValueAs: (value) => value.trim() })} />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="mb-3">
                                            <Input label= {t("platform.channels.config-wasab.phone-id")} errors={errors.meta_phone_number_id} {...register('meta_phone_number_id', { required: true, setValueAs: (value) => value.trim() })} />
                                        </div>
                                        <div className="mb-3">
                                            <Input label=  {t("platform.channels.config-wasab.app-id")} errors={errors.meta_app_id} {...register('meta_app_id', { required: true, setValueAs: (value) => value.trim() })} />
                                        </div>
                                        <div className="mb-3">
                                            <Input label= {t("platform.channels.config-wasab.access-token")} errors={errors.meta_access_token} {...register('meta_access_token', { required: true, setValueAs: (value) => value.trim() })} />
                                        </div>
                                    </>
                                )
                            }
                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => onRequestClose(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default WhatsAppBusinessModal